import { type Cart } from "@client/content/modules/Cart/types";
import ProductPrice from "@client/content/modules/ProductList/Content/Item/ProductPrice";
import date from "@client/lib/date";
import React from "react";

type Props = {
  currencyCode: string;

  info: Cart.SubscriptionInfo;
  oldPriceColor?: string;
  regularPriceStyle: React.CSSProperties;
  salePriceStyle: React.CSSProperties;
  taxPercentage: number;
};

export default ({ info, currencyCode, ...props }: Props) => {
  let hint: any;
  if (info.repeatDay || info.repeatLimit || info.repeatSalesPrice !== info.salesPrice) {
    hint = (
      <>
        Pay&nbsp;
        <ProductPrice {...props} price={{ currencyCode, price: info.price, salesPrice: info.salesPrice }} />
        {info.repeatSalesPrice !== info.salesPrice && (
          <>
            &nbsp;now&nbsp;and then&nbsp;
            <ProductPrice
              {...props}
              price={{ currencyCode, price: info.repeatPrice, salesPrice: info.repeatSalesPrice }}
            />
          </>
        )}
        &nbsp;per&nbsp;
        {info.repeatInterval > 1
          ? `${info.repeatInterval} ${info.repeatIntervalTimeUnit.toLowerCase()}`
          : info.repeatIntervalTimeUnit.toLowerCase()}
        {!!info.repeatLimit && (
          <strong>
            &nbsp;for&nbsp;
            {info.repeatLimit > 1
              ? `${info.repeatLimit} ${info.repeatIntervalTimeUnit.toLowerCase()}`
              : info.repeatIntervalTimeUnit.toLowerCase()}
          </strong>
        )}
        {!!info.repeatDay && (
          <div>
            &nbsp;starting <strong>{date.formatDate(info.nextRepeatDate)}</strong>
          </div>
        )}
      </>
    );
  }

  return (
    <div className="subscription_price">
      <div className="price">
        <ProductPrice {...props} price={{ currencyCode, price: info.repeatPrice, salesPrice: info.repeatSalesPrice }} />
        &nbsp;per&nbsp;
        {info.repeatInterval > 1
          ? `${info.repeatInterval} ${info.repeatIntervalTimeUnit.toLowerCase()}`
          : info.repeatIntervalTimeUnit.toLowerCase()}
      </div>
      <div className="hint">{hint}</div>
    </div>
  );
};
